import { supabase } from '@/integrations/supabase/client';

/**
 * Gets the workspace_id for the current authenticated user or token
 * Supports both normal user authentication and token-based authentication
 */
export async function getCurrentWorkspaceId(): Promise<string | null> {
  try {
    // Check if authenticated via token
    const tokenSession = localStorage.getItem('token_session');
    const storedToken = localStorage.getItem('solveiagro_access_token');
    
    if (tokenSession || storedToken) {
      // Token-based authentication
      const token = tokenSession ? JSON.parse(tokenSession).token : storedToken;
      
      const { data: tokenData, error: tokenError } = await supabase
        .from('access_tokens')
        .select('workspace_id')
        .eq('token', token)
        .eq('is_active', true)
        .or('expires_at.is.null,expires_at.gt.now()')
        .maybeSingle();

      if (tokenError) {
        console.error('Error fetching workspace from token:', tokenError);
        return null;
      }

      return tokenData?.workspace_id || null;
    } else {
      // Normal user authentication
      const { data: { user } } = await supabase.auth.getUser();
      
      if (!user) return null;

      const { data: workspaceUser, error: userError } = await supabase
        .from('workspace_users')
        .select('workspace_id')
        .eq('user_id', user.id)
        .eq('status', 'active')
        .maybeSingle();

      if (userError) {
        console.error('Error fetching workspace from user:', userError);
        return null;
      }

      return workspaceUser?.workspace_id || null;
    }
  } catch (error) {
    console.error('Error getting workspace_id:', error);
    return null;
  }
}
